export default function toDateString(date: Date): string {
    return date.toLocaleDateString('en-au', {
        day: 'numeric',
        month: 'short',
        year: 'numeric',
    });
}
